/**
 * @module navigation
 */
(function BackendAnchorLinkVisualizer() {

    function backendAnchorLinkVisualizer() {
        /**
         * // local object availability
         * @type {backendAnchorLinkVisualizer}
         * @private
         */
        var _this = this;


        var isBackend = window.Juzo.Context.isBackend();


        /**
         * @method cacheDom
         *  If it is in backend,
         *  assign {jQuery|HTMLElement(s)} to {backendAnchorLinkVisualizer} object
         */
        this.cacheDom = function () {
            if (isBackend) {
                this.$anchorLinkElements = $("[data-anchor-link='has-anchor-link']");
                this.$anchorLinkTargetElements = $("main a[href*='#']");
            }
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom();
            _this.render();

        };

        /**
         * @method render
         * @returns {undefined}
         */
        this.render = function () {
            _this.renderSourceElementsIdToolTip();
            _this.renderTargetElementIdToolTip();
        };

        /**
         * @method renderSourceElementsIdToolTip
         * @returns {undefined}
         */
        this.renderSourceElementsIdToolTip = function () {
            var $anchorLinkElements = _this.$anchorLinkElements;

            if ($anchorLinkElements.length > 0) {
                $anchorLinkElements.each(function () {
                    var element = this;
                    var elementId = element.id;
                    var title = 'Section Id: ';
                    var html = '<div class="section-id-tool-tip">' +
                        '<p class="section-id-tool-tip__title">' + title + '</p>' +
                        '<p class="section-id-tool-tip__body-text">' + elementId + '</p>' +
                        '</div>';
                    $(element).prepend(html).css('padding', "5px 15px");
                });
            }
        };

        /**
         * @method renderTargetElementIdToolTip
         * @returns {undefined}
         */
        this.renderTargetElementIdToolTip = function () {
            var $anchorLinkTargetElements = _this.$anchorLinkTargetElements;
            if ($anchorLinkTargetElements.length > 0) {
                $anchorLinkTargetElements.each(function () {
                    var element = this;
                    var string = 'Target Section Id: ';
                    var hash = element.hash;
                    $(element).attr("title", string + hash);
                });
            }
        };


        /**
         * initialize call
         */
        _this.init();


    }


    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }


    window.Juzo.backendAnchorLinkVisualizer = backendAnchorLinkVisualizer;
})();

// call the funciton when the DOM is ready
$(document).ready(function () {
    var isBackend = window.Juzo.Context.isBackend();
    if (isBackend) {
        window.Juzo.backendAnchorLinkVisualizer.call(window.Juzo.backendAnchorLinkVisualizer);
    }
});

// call the funciton when Neos Backend is reloaded
document.addEventListener('Neos.PageLoaded', function(event) {
    var isBackend = window.Juzo.Context.isBackend();
    if (isBackend) {
        window.Juzo.backendAnchorLinkVisualizer.call(window.Juzo.backendAnchorLinkVisualizer);
    }
}, false);